const config = require("config");

(function (angular) {
  "use strict";

  angular
    .module("alk.email")
    .service("alkEmailService", ["$q", "$http",
      function ($q, $http) {
        return {
          sendMapsureWelcomeEmail: sendMapsureWelcomeEmail,
          sendRouteReporterWelcomeEmail:sendRouteReporterWelcomeEmail
        };

        //Sends MapSure Email
        function sendMapsureWelcomeEmail(email, isNewSSO) {
          return $http.post(config.mapsureUrl + "user/welcome", {
            email: email,
            isNewSSOUser: isNewSSO
          });
        }

       //Sends FleetView Email
        function sendRouteReporterWelcomeEmail(email, isExistingSSO) {
          return $http.post(config.fleetViewUrl + "user/welcome", {
            email: email,
            isNewSSOUser: isExistingSSO
          });
        }
      }
    ]);
})(window.angular);



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-email/alkEmail.service.js